const MANILA_TIME_ZONE = 'Asia/Manila';

export const CONSULTATION_STATUSES = {
  PENDING: 'pending',
  SUBMITTED: 'submitted',
  SCHEDULED: 'scheduled',
};

export const normalizeConsultationStatus = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === CONSULTATION_STATUSES.SUBMITTED) return CONSULTATION_STATUSES.SUBMITTED;
  if (normalized === CONSULTATION_STATUSES.SCHEDULED) return CONSULTATION_STATUSES.SCHEDULED;
  return CONSULTATION_STATUSES.PENDING;
};

const getManilaParts = (date) => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: MANILA_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  const lookup = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return {
    year: lookup.year,
    month: lookup.month,
    day: lookup.day,
    hour: lookup.hour === '24' ? '00' : lookup.hour,
    minute: lookup.minute,
  };
};

export const toDatetimeLocalValue = (isoValue) => {
  if (!isoValue) return '';

  const parsed = new Date(isoValue);
  if (Number.isNaN(parsed.getTime())) return '';

  const { year, month, day, hour, minute } = getManilaParts(parsed);
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

export const consultationIsoFromLocal = (localValue) => {
  const trimmed = String(localValue || '').trim();
  if (!trimmed) return null;

  const parsed = new Date(`${trimmed}:00+08:00`);
  if (Number.isNaN(parsed.getTime())) return null;

  return parsed.toISOString();
};

export const formatConsultationDateTime = (isoValue) => {
  if (!isoValue) return '';

  const parsed = new Date(isoValue);
  if (Number.isNaN(parsed.getTime())) return '';

  try {
    return parsed.toLocaleString('en-PH', {
      timeZone: MANILA_TIME_ZONE,
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return parsed.toISOString();
  }
};

export const getConsultationStatusLabel = (status) => {
  const normalized = normalizeConsultationStatus(status);

  if (normalized === CONSULTATION_STATUSES.SCHEDULED) {
    return 'Scheduled';
  }

  if (normalized === CONSULTATION_STATUSES.SUBMITTED) {
    return 'Submitted by client — review required';
  }

  return 'Awaiting client submission';
};
